/**
 * Solicita la ubicación GPS actual del usuario
 * @returns {Promise<{latitude: number, longitude: number, accuracy: number}>}
 */
export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('La geolocalización no está soportada por este navegador'));
      return;
    }

    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 300000
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy
        });
      },
      (error) => {
        let errorMessage = 'Error desconocido al obtener la ubicación';
        
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'El usuario denegó la solicitud de geolocalización';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'La información de ubicación no está disponible';
            break;
          case error.TIMEOUT:
            errorMessage = 'La solicitud de ubicación ha expirado';
            break;
        }
        
        reject(new Error(errorMessage));
      },
      options
    );
  });
};

/**
 * Solicita la ubicación con manejo de errores más amigable
 * @returns {Promise<{latitude: number, longitude: number, accuracy: number} | null>}
 */
export const requestLocationWithFallback = async () => {
  try {
    const location = await getCurrentLocation();
    console.log('Ubicación obtenida exitosamente:', location);
    return location;
  } catch (error) {
    console.warn('No se pudo obtener la ubicación GPS:', error.message);
    return null;
  }
}; 